/* src/app/checkup/features/checkup-feature.component.scss */
/*# sourceMappingURL=checkup-feature.component.css.map */
